import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Helmet from 'react-helmet';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import PropTypes from 'prop-types';
import Icon from '@mdi/react'
import { mdiAndroid, mdiApple, mdiWindows } from '@mdi/js';


const AppsPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.AppsPageData.edges[0]
  return (
    <Layout>
      <Helmet>
        <html lang={locale === 'en' ? 'en' : 'de'} />
          <title>
            {
              locale === 'en' ?
                'Apps - presono' :
                'Apps - presono'
            }
          </title>
          <meta
            name="description"
            content={
              locale === 'en' ?
                'With our apps for Android, iPhone, MacOS and Windows for presono you can present professionally both online and offline!' :
                'Mit unseren Apps für Android, iPhone, MacOS und Windows können Sie sowohl online als auch offline professionell präsentieren mit presono!'
            }
          />
      </Helmet>
      <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
      <section className="solutions sub apps">

        <section className="headliner starfield t2 b2 pusher">
          <div className="container">
            { locale === 'en' ?
              <div className="column">
                <h1> <strong>Present</strong> anywhere, anytime</h1>
                <p>With our apps for Android, iPhone, MacOS and Windows for presono you can present professionally both online and offline!</p>
              </div>
              :
              <div className="column">
                <h1>Immer und überall <strong>präsentieren!</strong></h1>
                <p>Mit unseren Apps für Android, iPhone, MacOS und Windows können Sie sowohl online als auch offline professionell präsentieren mit presono!</p>
            </div>
            }
          </div>


        </section>
        <div className="container special-bg">
          <div className="columns">
            <div className="column is-half">
              <div className="card">
                <div className="card-content">
                  <div className="media">
                    <div className="media-content">
                      <h2 className="title is-4">{locale === 'en' ? 'Download Desktop Apps' : 'Desktop Apps Herunterladen'}</h2>
                      <p><span className="underline">{locale === 'en' ? 'On Windows & Mac you can be productive Online & Offline with our dedicated desktop Apps.' : 'Mit unseren Desktop-Apps können Sie unter Windows und Mac online & offline produktiv sein.'}</span></p>
                    </div>
                  </div>
                  <div className="content">
                    <div className="card-image">
                      <figure className="image">
                        <img src={withPrefix('/img/mac.png')} alt="Desktop App" />
                      </figure>
                    </div>
                  </div>
                  <div className="content">
                    <div className="columns">
                      <div className="column">
                        <OutboundLink className="button is-rounded features-button" target="_blank" href="https://download.presono.com/latest/win">
                          <span className="icon">
                          <Icon path={mdiWindows}
                            size={"20px"}
                            color="#fff"
                            />
                          </span>
                          <span>Windows</span>
                        </OutboundLink>
                        <OutboundLink className="arm-app" target="_blank" href="https://download.presono.com/latest/arm">
                          <span>Windows ARM</span>
                        </OutboundLink>
                      </div>
                      <div className="column">
                        <OutboundLink className="button is-rounded features-button" target="_blank" href="https://download.presono.com/latest/mac">
                          <span className="icon">
                          <Icon path={mdiApple}
                            size={"20px"}
                            color="#fff"
                            />
                          </span>
                          <span>MacOS</span>
                        </OutboundLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="column is-half">
              <div className="card">
                <div className="card-content">
                  <div className="media">
                    <div className="media-content">
                      <h2 className="title">{locale === 'en' ? 'Get Smartphone Apps' : 'Smartphone Apps Nutzen' }</h2>
                      <p><span className="underline">{locale === 'en' ? 'With our presono Viewer Apps you can view and present your presentations on the go!' : 'Mit presono Viewer können Sie Ihre Präsentationen auch unterwegs auf ihrem iOS oder Android Geräte ansehen und präsentieren!' }</span></p>
                    </div>
                  </div>
                  <div className="content">
                    <div className="card-image">
                      <figure className="image">
                        <img src={withPrefix('/img/phone.png')} alt="Desktop App" />
                      </figure>
                    </div>
                  </div>
                  <div className="content">
                    <div className="columns">
                      <div className="column">
                        <OutboundLink className="button is-rounded features-button" target="_blank" href="https://play.google.com/store/apps/details?id=com.presono.androidcloud">
                          <span className="icon">
                          <Icon path={mdiAndroid}
                            size={"20px"}
                            color="#fff"
                            />
                          </span>
                          <span>Android</span>
                        </OutboundLink>
                      </div>
                      <div className="column">
                        <OutboundLink className="button is-rounded features-button" target="_blank" href="https://apps.apple.com/app/presono/id1447221630">
                          <span className="icon">
                          <Icon path={mdiApple}
                            size={"20px"}
                            color="#fff"
                            />
                          </span>
                          <span>iOS</span>
                        </OutboundLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Newsletter newsletter={data.frontmatter} locale={locale} />
      <Footer locale={locale} />
    </Layout>
  )
}

export default AppsPage;

AppsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query AppsPageContent($locale: String) {
    AppsPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_apps"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          langSwitch
        }
      }
    }
  }
}
`
